const PREFIX = 'CATEGORY'

export const CATEGORY_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const CATEGORY_FETCH = `${PREFIX}_FETCH`
export const CATEGORY_FETCH_ERRORS = `${PREFIX}_FETCH_ERRORS`
export const CATEGORY_SET = `${PREFIX}_SET`
export const CATEGORY_DEFAULT_STRUCTURE = `${PREFIX}_CATEGORY_DEFAULT_STRUCTURE`
